import {NodeIssue} from 'common/src/components/CLCardsMap/CardsMapContainer/CardsMapContainer.types';
import {CampaignStep} from '../campaignWorkflow/campaignWorkflow.enums';
import {CampaignsStepsInformation, CampaignType} from './campaigns.types';
import {CLIssueLevel} from '../issues/issues.types';
import {CAMPAIGN_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';

const DEFAULT_CAMPAIGN_NAME = 'My New Campaign';

// Maybe this file should be deleted, and its contents moved to campaigns.config.ts
const campaignTypeNameMap: Record<CampaignType, string> = {
  [CampaignType.DynamicBanners]: 'Display',
  [CampaignType.NativeAds]: 'Native',
  [CampaignType.TikTokAds]: 'TikTok',
  [CampaignType.YoutubeVideoAds]: 'YouTube',
  [CampaignType.FacebookVideoAds]: 'Facebook',
  [CampaignType.SnapchatAds]: 'Snapchat',
  [CampaignType.LinkedInAds]: 'LinkedIn',
  [CampaignType.InteractiveVideoAds]: 'Interactive Video',
  [CampaignType.DoohImageAd]: 'Digital Out-of-Home Image',
  [CampaignType.VideoAds]: 'Video',
  [CampaignType.InBannerVideoAds]: 'In-Banner Video',
  [CampaignType.AudioAds]: 'Audio',
  [CampaignType.ThirdPartyAdTracking]: 'Third Party Ad Tracking',
};

const campaignStepsInformationInitialValues: CampaignsStepsInformation = {
  [CampaignStep.Placements]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.ConceptPlan]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.CampaignLogic]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.AdsVariations]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.Home]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.Brief]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.Trackers]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.Tearsheet]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.TearsheetPreview]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.Insights]: {
    issues: 0,
    comments: 0,
  },
  [CampaignStep.AdVariationAnalysis]: {
    issues: 0,
    comments: 0,
  },
};

const MAX_CAMPAIGN_NAME_LENGTH = 100;

const campaignAttributionIssue: NodeIssue = {
  message: 'Attribution enabled, but no active data sources are configured',
  level: CLIssueLevel.Error,
  issueKey: 'campaign-attribution-issue',
  nodeId: CAMPAIGN_NODE_ID,
};

export {
  DEFAULT_CAMPAIGN_NAME,
  campaignTypeNameMap,
  MAX_CAMPAIGN_NAME_LENGTH,
  campaignStepsInformationInitialValues,
  campaignAttributionIssue,
};
